import { ChangeDetectorRef, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbAccordion, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { ModalType } from 'src/app/core/enums/modalTypesEnum';
import { OwnerEntityType } from 'src/app/core/enums/owner-entity-type-enum';
import { RequisitionStatus } from 'src/app/core/enums/requisition-status-enum';
import { TimeLineType } from 'src/app/core/enums/timeline-type-enum';
import { PaymentSearchModel } from 'src/app/core/models/commerce/payment-search.model';
import { PaymentModel } from 'src/app/core/models/commerce/payment.model';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { DataType } from 'src/app/core/models/document/custom-field-base-model';
import { DocumentStatus, TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { ErrorModel } from 'src/app/core/models/error.model';
import { ClientSignatureRequestModel } from 'src/app/core/models/members/client/client-signature-request.model';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { CustomFieldGroupModel } from 'src/app/core/models/myfile/custom-field-group.model';
import { CustomFieldSubGroupModel } from 'src/app/core/models/myfile/custom-field-sub-group.model';
import { MyfileModel, MyfileTypes } from 'src/app/core/models/myfile/myfile.model';
import { RequisitionViewDataModel } from 'src/app/core/models/requisition/requisition-view-data.model';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { TimelineModel } from 'src/app/core/models/timeline/timeline.model';
import { Roles } from 'src/app/core/security/roles';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { UserContextType, AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { MyfileListService } from 'src/app/core/services/list-services/myfile-list.service';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { CheckoutModalService } from 'src/app/core/services/modal-services/checkout-modal.service';
import { ClientModalService } from 'src/app/core/services/modal-services/client-modal.service';
import { ContactViewModalService } from 'src/app/core/services/modal-services/contact-view-module.service';
import { MyfileModalService } from 'src/app/core/services/modal-services/myfile-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { TimelineNoteModalService } from 'src/app/core/services/modal-services/timeline-note-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SignatureModalService } from '../signature-request/signature-modal.service';
import { AssigneesModalService } from 'src/app/core/services/modal-services/assignees-modal.service';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';
import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { CreditCardPaymentInfoModel } from 'src/app/core/models/members/user/credit-card-payment-info-model';
import { InvoiceModel } from 'src/app/core/models/commerce/invoice.model';
import { InvoiceApprovalRequestModel } from 'src/app/core/models/commerce/invoice-approval-email.model';

const enum RequisitionListUpdateValues {
  Default = 0,
  Delete = 1,
  Invoiced = 2
}

@Component({
  selector: 'app-requisition-modal',
  templateUrl: './requisition-modal.component.html',
  styleUrls: ['./requisition-modal.component.scss']
})

export class RequisitionModalComponent extends BaseModalWithProfilePhotoComponent {

  @ViewChildren('pageAccordion') pageAccordions!: QueryList<NgbAccordion>;

  includeTaxOptionsList = [
    { value: true, selectedText: $localize`:@@:Request New Signature`, default: true },
    { value: false, selectedText: $localize`:@@:Use Signature on File` },
  ]

  accordionIsCollapsed: boolean = true;

  myfileTotal!: Observable<number>;
  myfilesList!: Observable<MyfileModel[] | undefined>;
  myfiles?: any;

  unsubscribe: Subscription[] = [];

  billableUser: UserBaseModel | undefined = undefined;

  activeIdIndex: number = 0;
  requisitionStatus?: RequisitionStatus = RequisitionStatus.Draft;
  contactEdited: boolean = false;
  clientSelectModal = ModalType.ClientModalPickList;
  contactSelectModal = ModalType.ContactModalPickList;
  subscriptionEmitter?: boolean;
  myfile: MyfileModel = new MyfileModel();
  defaultCustomFieldGroup: CustomFieldGroupModel = new CustomFieldGroupModel();
  myfileCustomFieldsGroups: CustomFieldGroupModel[] = [];
  userContext: UserContextType = this.authMyFileService.currentUserContextValue;
  requisition: RequisitionModel = new RequisitionModel();
  newRequisition: boolean = false;
  myFileValid: boolean = true;
  datePattern = GlobalComponent.datePattern;
  timeLineTag = "";
  entityId = "";
  clientId = "";
  ownerType = OwnerEntityType.Requisition;
  entityTypeId = EntityTypeEnum.Requisition;
  invoiceMyfileList: MyfileModel[] = [];
  spinnerIsShown: boolean = false;
  timeLineItem: TimelineModel = new TimelineModel();

  isTypeRetainer: boolean = false;

  totalEDocuments!: Observable<number>;

  tempFiles: any;

  requisitionName: string = $localize`:@@:New Requisition`

  securityPermissionTimeLineCreateNote: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineCreateNote);
  securityPermissionRequisitionCreateInvoice: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateInvoice);
  securityPermissionRequisitionCreateCheque: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateCheque);
  securityPermissionRequisitionDeleteInvoice: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionDeleteInvoice);
  securityPermissionRequisitionDeleteCheque: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionDeleteCheque);

  securityPermissionRequisitionCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreate);
  securityPermissionRequisitionIncomplete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionIncomplete);
  securityPermissionRequisitionComplete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionComplete);

  securityPermissionRequisitionUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionUpdate);

  securityPermissionRequisitionDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionDelete);
  securityPermissionRequisitionSubmit: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionSubmit);
  securityPermissionRequisitionReject: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionReject);
  securityPermissionRequisitionProcess: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionProcess);
  securityPermissionRequisitionCreatePayment: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreatePayment);
  securityPermissionRequisitionRefundPayment: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionRefundPayment);
  securityPermissionRequisitionViewPayment: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionViewPayment);

  securityPermissionUserReadLimitedToScope: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userReadLimitedToScope);

  securityRoleIsUserGuest: boolean = this.authMyFileService.isInRole(Roles.guest);

  enumRequisitionStatus = RequisitionStatus;
  enumMyfileTypes = MyfileTypes;
  enumDocumentStatus = DocumentStatus;
  enumTemplateDocumentType = TemplateDocumentType;

  constructor(
    protected aIChatModalService: AIChatModalService,
    protected myFileListService: MyfileListService,
    protected checkoutModalService: CheckoutModalService,
    protected myTimelineNoteModalService: TimelineNoteModalService,
    protected myFileModalService: MyfileModalService,
    protected assigneesModalService: AssigneesModalService,
    protected myClientViewService: ClientModalService,
    protected changeDetector: ChangeDetectorRef,
    protected badgeCountService: BadgeCountService,
    protected myContactViewService: ContactViewModalService,
    protected pdfModalService: PdfViewerModalService,
    protected clientSignatureModalService: SignatureModalService,
    protected aiApiService: AiApiService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
    this.myfilesList = this.myFileListService.myfiles$
    this.myfileTotal = this.myFileListService.total$;
  }

  @Input() public override model: RequisitionViewDataModel = new RequisitionViewDataModel();
  @Input() public documentTemplateId: string | undefined = undefined;
  @Input() public refreshList: any;
  @Input() public priceTotal: number = 0;
  @Output() modelChange = new EventEmitter<any>();

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
    this.myFileListService.clearSourceId();
    this.myfiles = [];
    this.myfile = new MyfileModel;
    this.model = new RequisitionViewDataModel();
  }

  ngOnInit(): void {
    this.spinnerIsShown = true;

    if (this.model.requisition && this.model.requisition.assigneeIds && this.model.requisition.assigneeIds.length > 0 && this.model.requisition.assignees && this.model.requisition.assignees.length > 0) {
      this.billableUser = this.model.requisition.assignees.find(x => x.id == this.model.requisition!.assigneeIds![this.model.requisition!.assigneeIds!.length - 1]);
    } else if (this.model && this.model.requisition) {
      this.billableUser = this.model.requisition.createdBy;
    }
    if (this.model.requisition && this.model.requisition.assigneeIds && this.model.requisition.assigneeIds.length > 0 && this.model.requisition.assignees && this.model.requisition.assignees.length > 0) {
      this.model.requisition.assignees.sort((a, b) => this.model.requisition!.assigneeIds!.indexOf(a.id!) - this.model.requisition!.assigneeIds!.indexOf(b.id!));
    }
    var sub: Subscription = this.myfilesList.subscribe((result: MyfileModel[] | undefined) => {

      if (result != undefined) {

        if (result.length == 0 && this.model.myfile) {
          this.myfiles = [];
          this.myfiles.push(this.model.myfile)
        } else {
          this.myfiles = Object.assign([], result);
        }
        this.model.myfileList.items = [];
        this.invoiceMyfileList = [];
        if (this.myfiles[0] && this.myfiles[0].id) {
          this.model.myfileList.items.push(this.myfiles[0]);
          this.spinnerIsShown = true;
          this.myFileApiService.getMyFile(this.myfiles[0].id)
            .subscribe((myfileModel: MyfileModel | undefined) => {
              this.spinnerIsShown = false;
              this.myfileCustomFieldsGroups = [];
              this.defaultCustomFieldGroup = new CustomFieldGroupModel();
              this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup);
              if (myfileModel) {
                this.myfile = myfileModel;
              }
              if (this.myfile.customFields) {
                this.myfile.customFields.forEach((customField: any, index: number) => {
                  if (customField.dataType == 2) {
                    customField.value = this.dateRequestFormat(customField.value);
                  }
                  if (customField.groupName && customField.groupName != "") {
                    var groupDoesNotExists: boolean = true;
                    this.myfileCustomFieldsGroups.forEach(customFieldGroup => {
                      if (groupDoesNotExists && customFieldGroup.groupName == customField.groupName) {
                        groupDoesNotExists = false
                        customFieldGroup.group.push(customField);
                      }
                    })
                    if (groupDoesNotExists) {
                      this.defaultCustomFieldGroup = new CustomFieldGroupModel();
                      this.defaultCustomFieldGroup.groupName = customField.groupName;
                      this.defaultCustomFieldGroup.group.push(customField);
                      this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup)
                    }
                  } else {
                    this.defaultCustomFieldGroup = this.myfileCustomFieldsGroups[0];
                    this.defaultCustomFieldGroup.group.push(customField);
                    this.myfileCustomFieldsGroups[0] = this.defaultCustomFieldGroup;
                  }
                });
              }
              this.setSubGroups();
              if (this.myfileCustomFieldsGroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0].group && this.myfileCustomFieldsGroups[0].subgroups[0].group.length == 0) {
                this.activeIdIndex = 1;
              }
            });
        } else if (this.model.myfile) {
          this.myfile = this.model.myfile;
          if (this.myfile.customFields) {
            this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup);

            this.myfile.customFields.forEach((customField: any, index: number) => {
              if (customField.dataType == 2) {
                customField.value = this.dateRequestFormat(customField.value);
              }

              if (customField.groupName && customField.groupName != "") {
                var groupDoesNotExists: boolean = true;
                this.myfileCustomFieldsGroups.forEach(customFieldGroup => {
                  if (groupDoesNotExists && customFieldGroup.groupName == customField.groupName) {
                    groupDoesNotExists = false
                    customFieldGroup.group.push(customField);
                  }
                })
                if (groupDoesNotExists) {
                  this.defaultCustomFieldGroup = new CustomFieldGroupModel();
                  this.defaultCustomFieldGroup.groupName = customField.groupName;
                  this.defaultCustomFieldGroup.group.push(customField);
                  this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup)
                }
              } else {
                this.defaultCustomFieldGroup = this.myfileCustomFieldsGroups[0];
                this.defaultCustomFieldGroup.group.push(customField);
                this.myfileCustomFieldsGroups[0] = this.defaultCustomFieldGroup;
              }
            });
          }
          this.setSubGroups();
          if (this.myfileCustomFieldsGroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0].group && this.myfileCustomFieldsGroups[0].subgroups[0].group.length == 0) {
            this.activeIdIndex = 1;
          }
        }
        if (this.authMyFileService.isInRole(Roles.admin) || this.authMyFileService.isInRole(Roles.csr)) {
          this.model.myfileList.items = this.myfiles;
          this.model.myfileList.items?.forEach((myfile: MyfileModel) => {
            if (myfile && myfile.type == TemplateDocumentType.Invoice && (myfile.status == DocumentStatus.New || DocumentStatus.Approved)) {
              this.invoiceMyfileList.push(myfile)
            }
          })
        }
        if (this.authMyFileService.isInRole(Roles.witness)) {
          this.model.myfileList.items = [];
          this.myfiles.forEach((myfile: MyfileModel, index: number) => {
            if (index == 0) {
              this.model.myfileList.items!.push(myfile);
            } else {
              if (myfile.status != DocumentStatus.New) {
                this.model.myfileList.items!.push(myfile);
              }
            }
          });
        }
      } else {
        this.spinnerIsShown = false;
      }
    });

    this.unsubscribe.push(sub);

    if (this.model.requisition) {
      if (this.priceTotal == 0) {
        if (this.model.requisition.total) {
          this.priceTotal = this.model.requisition.total
        } else {
          this.priceTotal = this.model.requisition.price + this.model.requisition.processingFee;
        }
      }
      this.requisition = this.model.requisition;
      if (this.model.requisition.dateOfLoss) {
        this.model.requisition.dateOfLoss = GlobalComponent.dateTransform(this.model.requisition.dateOfLoss, false);
      }
      if (this.requisition.client == undefined) {
        this.newRequisition = true;
        this.requisition.client = new ClientModel();
        this.requisition.matterNumber = "";
        this.requisition.dateOfLoss = "";
      }
      if (this.requisition.account == undefined) {
        this.requisition.account = new ContactModel();
      }
      if (this.requisition.id) {
        this.entityId = this.requisition.id;

        if (this.authMyFileService.isInRole(Roles.sandbox) || this.authMyFileService.isInRole(Roles.witness)) {
          if (this.requisition.status === RequisitionStatus.Completed || this.requisition.status === RequisitionStatus.Incompleted) {
            this.myFileListService.types = undefined;
          } else {
            this.myFileListService.types = [TemplateDocumentType.Retainer, TemplateDocumentType.Document, TemplateDocumentType.Other]
          }
        }

        this.myFileListService.sourceId = this.requisition.id;
      }
      if (this.requisition.client.id) {
        this.clientId = this.requisition.client.id;
      }
      if (this.requisition.number) {
        this.timeLineTag = `Requisition ${this.requisition.number}`
      } else {
        this.timeLineTag = `New Requisition`;
        this.spinnerIsShown = false;
      }
    }
    if (this.documentTemplateId) {
      this.requisition.status = RequisitionStatus.Draft;
    }

    if (this.requisition.status) {
      this.requisitionStatus = this.requisition.status;
    }

    if (this.requisition.status == RequisitionStatus.Draft) {
      this.disableEditing = false;
    } else {
      this.disableEditing = true;
    }

    this.requisitionStatus = this.requisition.status;

    if (this.requisition && this.requisition.assignees && this.requisition.assignees.length > 0) {

      this.requisition.assignees.forEach(assignee => {
        if (assignee.id) {
          this.getEntityPhoto(assignee, EntityTypeEnum.User);
        }
      })
    }

  }

  updateActiveIDIndex(groupIndex: number) {
    this.activeIdIndex = groupIndex;
  }

  selectPageMyfiles(page: string) {
    this.myFileListService.startIndex = parseInt(page, 10) || 1;
  }

  typeRename(type: TemplateDocumentType | undefined): string {
    if (type)
      return TemplateDocumentType[type];
    return TemplateDocumentType[0]
  }

  formatInputMyfiles(input: HTMLInputElement) {
    input.value = input.value.replace(GlobalComponent.FILTER_PAG_REGEX, '');
  }
  get pagingInfoMyfiles() {

    let from = this.myFileListService.pageIndex == 0 ?
      (this.myFileListService.pageSize * this.myFileListService.pageIndex) + 1
      : this.myFileListService.pageSize * this.myFileListService.pageIndex;

    let to = (this.myFileListService.pageSize * this.myFileListService.pageIndex) + this.myFileListService.pageSize;

    if (to > this.myFileListService.totalRecords) {
      to = this.myFileListService.totalRecords;

    }

    if (from <= 0 || this.myFileListService.totalRecords == 0) {
      from = 0;

    }
    return `Showing ${from} to ${to} of ${this.myFileListService.totalRecords} records`;
  }

  setSubGroups() {

    this.myfileCustomFieldsGroups.forEach(group => {
      var defaultSubgroup: CustomFieldSubGroupModel = new CustomFieldSubGroupModel;
      group.subgroups[0] = defaultSubgroup;
      group.group.forEach(customField => {

        if (customField.groupSubName && customField.groupSubName != null && customField.groupSubName != "") {
          var groupDoesNotExists: boolean = true;
          group.subgroups.forEach(customFieldSubGroup => {
            if (groupDoesNotExists && customFieldSubGroup.subGroupName == customField.groupSubName) {
              groupDoesNotExists = false
              customFieldSubGroup.group.push(customField);
            }
          })
          if (groupDoesNotExists) {
            var newCustomFieldSubGroup = new CustomFieldSubGroupModel();
            newCustomFieldSubGroup.subGroupName = customField.groupSubName;
            newCustomFieldSubGroup.group.push(customField);
            group.subgroups.push(newCustomFieldSubGroup);
          }
        } else {
          group.subgroups[0].group.push(customField);
        }
      })
    })
  }

  nameTrim(name: string | undefined): string | undefined {
    if (name) {
      name = (name.substring(name.indexOf(' ') + 1)).split("#")[0]
    }
    return name;
  }

  updateList(type: RequisitionListUpdateValues) {
    if (this.refreshList) {
      switch (type) {
        case RequisitionListUpdateValues.Default:
          for (var i = 0; i < this.refreshList.length; i++) {
            if (this.refreshList[i].id == this.requisition.id) {
              this.refreshList[i].status = this.requisition.status;
              this.refreshList[i].client = this.requisition.client;
              this.refreshList[i].account = this.requisition.account;
              this.refreshList[i].matterNumber = this.requisition.matterNumber;
            }
          }
          break;
        case RequisitionListUpdateValues.Delete:
          this.refreshList.forEach((element: any, index: any) => {
            if (element.id == this.model.requisition?.id) {
              this.refreshList.splice(index, 1);
            }
          });
          break;
      }
    }
    this.badgeCountService.getBadgeCount();
  }

  submitRetainer() {
    this.submitted = true;
    if (this.validate()) {
      this.submitted = false;
      this.myFileListService.startIndex = 1;
      this.requisition.status = RequisitionStatus.Completed;
      this.updateStatusOnList(RequisitionStatus.Completed, `Complete`);
    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  newNote() {
    this.timeLineItem.ownerId = this.requisition.id;
    this.timeLineItem.type = TimeLineType.Note;
    this.timeLineItem.ownerEntityType = OwnerEntityType.Requisition;
    this.myTimelineNoteModalService.openModal(this.timeLineItem, false);
    var sub: Subscription = this.myTimelineNoteModalService.modelChanged.subscribe((result: any) => {
      if (result) {
        this.timeLineItem = new TimelineModel;
      }
      sub.unsubscribe();
    })
  }

  onCreate() {
    this.spinnerIsShown = true;
    if (this.requisition.client.id && this.requisition.account.id) {
      this.requisition.clientId = this.requisition.client.id;
      this.requisition.accountId = this.requisition.account.id;
      this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, true);
      if (this.model.fileUpload) {
        this.requisition.fileUpload = this.model.fileUpload;
      }
      this.myFileApiService.newRequisition(this.requisition)
        .subscribe((result: RequisitionModel | undefined) => {
          if (result) {
            if (result.id != null) {
              this.myfile.sourceId = result.id;
              this.updateMyfileList();
              if (this.myfile.customFields) {
                this.myfile.customFields.forEach(element => {
                  if (element.dataType == 2) {
                    if (element.value) {
                      element.value = this.swapFormat(element.value);
                    }
                  }
                });
              }
              this.myFileApiService.newMyFile(this.myfile)
                .subscribe((result: MyfileModel | undefined) => {
                  if (result) {
                    this.toasterNotificationService.showSuccess($localize`:@@Toast_Success_RequisitionCreated: Requisition Created`, $localize`:@@Toast_Success_GeneralTitle:Success`);
                    this.contactEdited = false;
                    this.badgeCountService.getBadgeCount();
                    this.spinnerIsShown = false;
                    this.close();
                  } else {
                    this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, false);
                    this.spinnerIsShown = false;
                  }
                });
            } else {
              this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, false);
              this.spinnerIsShown = false;
            }
          } else {
            this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, false);
            this.spinnerIsShown = false;
          }
        });
    } else {
      this.spinnerIsShown = false;
    }

  }

  stringLengthvalidate(date: string | undefined): number {
    if (date == undefined) {
      return 0;
    } else {
      if (this.requisition.dateOfLoss.length == 8) {
        if (!this.requisition.dateOfLoss.includes('/')) {
          this.requisition.dateOfLoss = this.requisition.dateOfLoss.substring(0, 2) + "/" + this.requisition.dateOfLoss.substring(2, 4) + "/" + this.requisition.dateOfLoss.substring(4, 8)
        }
      }
      return date.length
    }
  }

  /**
   * Used for Legacy server data storage. add a 0 if fields for MM or DD are less then 10, when data recived from server. 
   * @param date the date as a string
   * @returns converted string with date
   */
  dateRequestFormat(date: string | undefined): string {
    var newDate: string = "";
    if (date == undefined) {
      date = "";
    }
    if (date.includes('/')) {
      date.split('/').forEach((currentValue) => {
        if (currentValue.length == 1) {
          currentValue = `0${currentValue}`;
        }
        if (newDate == "") {
          newDate = `${currentValue}`;
        } else {
          newDate = `${newDate}/${currentValue}`;
        }
      });
    }
    return this.swapFormat(newDate);
  }

  /**
   * Used for Legacy server data storage. Server stores Values of Data Type 2 as MM/DD/YYYY but webclient works in DD/MM/YYYY. This function converts MM and DD fields 
   * @param date the date as a string
   * @returns converted string with date
   */
  swapFormat(date: string): string {
    return `${date.split('/')[1]}/${date.split('/')[0]}/${date.split('/')[2]}`
  }


  save() {
    this.submitted = true;
    if (this.validate()) {
      if (this.requisition.id) {
        this.onUpdate();
      } else {
        this.onCreate();
      }
      this.submitted = false;
    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    }
  }

  validate(): boolean {
    if (this.requisition.dateOfLoss.length == 8) {

      if (!this.requisition.dateOfLoss.includes('/')) {
        this.requisition.dateOfLoss = this.requisition.dateOfLoss.substring(0, 2) + "/" + this.requisition.dateOfLoss.substring(2, 4) + "/" + this.requisition.dateOfLoss.substring(4, 8)
      }
    }
    if (
      this.requisition.account.id != null
      && this.requisition.account.id != ''
      && this.requisition.client.id != null
      && this.requisition.client.id != ''
      && this.requisition.dateOfLoss != null
      && this.requisition.dateOfLoss != ''
      && this.requisition.dateOfLoss.length == 10 && this.datePattern.test(this.requisition.dateOfLoss)
    ) {

      this.myFileValid = true;
      this.myfile.customFields?.forEach((currentValue) => {

        if (
          currentValue.value == null
          || currentValue.value == ''
        ) {
          currentValue.value = "";
        }
      });
      if (this.myFileValid) {
        return true
      }
    }
    return false;
  }

  getDocumentImageUrl(data: any) {
    if (data.imageUrl) {
      var filename = data.imageUrl.split('/').pop();
      if (filename.includes("120.png")) {
        filename = "myfile_border.jpg";
      }
      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

  updateTimeLineForSignatureSubmission(email: string, showNotification: boolean, closeModal: boolean) {
    var activityUpdate: TimelineModel = new TimelineModel();
    activityUpdate.ownerEntityType = OwnerEntityType.Requisition;
    activityUpdate.ownerId = this.requisition.id;
    activityUpdate.description = `Client signature requested by: ${this.userContext?.firstName} ${this.userContext?.lastName} at email ${email}`;
    activityUpdate.name = `Requisition Status Change: Signature Pending`
    activityUpdate.type = TimeLineType.Event;
    var sub = this.myFileApiService.newTimelineItem(activityUpdate).subscribe((result: any) => {
      if (result) {
        if (showNotification) {
          this.toasterNotificationService.showSuccess($localize`:@@:A signature request was emailed to your client`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        if (closeModal) {
          this.close();
        }
      }
      sub.unsubscribe();
    });

  }

  sentRequestSignature() {
    if (this.model && this.model.myfileList && this.model.myfileList.items && this.model.myfileList.items[0] && this.model.myfileList.items[0].id) {
      this.myfileRequestSignature(this.model.myfileList.items[0].id);
    } else {
      this.toasterNotificationService.showError('MyFile failed to resend the signature, document could not be found.', 'Error');
    }

  }

  requisitionRequestSignature() {
    this.submitted = true;
    if (this.validate()) {
      this.submitted = false;
      this.spinnerIsShown = true;
      this.checkoutModalService.openModal(this.requisition);
      var sub: Subscription = this.checkoutModalService.modelChanged.subscribe((result: RequisitionModel) => {
        if (result.status == RequisitionStatus.Submitted) {
          this.toasterNotificationService.showSuccess($localize`:@@:Requisition Purchased`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          if (this.requisition.isExplicitClientSignatureRequired === true) {
            this.updateTimeLineForSignatureSubmission(this.requisition.client.email, true, true);
          } else {
            this.requisition = result;
            this.myFileApiService.updateRequisitionStatus(this.requisition, (`Requisition Submitted by: ${this.userContext?.firstName} ${this.userContext?.lastName}`)).subscribe((response: any) => {
              if (response) {
                this.updateList(RequisitionListUpdateValues.Default);
                this.modalRef.close();
              }
              this.spinnerIsShown = false
            });
          }
          this.myFileListService.startIndex = 1;
        }
        this.spinnerIsShown = false;
        sub.unsubscribe();
      })

    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  purchase() {
    this.submitted = true;
    if (this.validate()) {
      this.submitted = false;
      this.spinnerIsShown = true;
      this.checkoutModalService.openModal(this.requisition);
      var sub: Subscription = this.checkoutModalService.modelChanged.subscribe((result: RequisitionModel) => {
        if (result.status == RequisitionStatus.Submitted) {
          this.myFileListService.startIndex = 1;
          this.requisition = result;
          this.myFileApiService.updateRequisitionStatus(this.requisition, (`Client signature request submitted by: ${this.userContext?.firstName} ${this.userContext?.lastName} to email: `)).subscribe((response: any) => {
            if (response) {
              this.updateList(RequisitionListUpdateValues.Default);
              this.toasterNotificationService.showSuccess($localize`:@@:Requisition Purchased`, $localize`:@@Toast_Success_GeneralTitle:Success`);
              this.modalRef.close();
            }
            this.spinnerIsShown = false
          });
        }
        this.spinnerIsShown = false;
        sub.unsubscribe();
      })

    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  reject() {
    Swal.fire({
      title: $localize`:@@:Reject Requisition`,
      text: $localize`:@@:Are you sure you want to Reject this requisition?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Yes, Reject`,
      cancelButtonText: $localize`:@@:No, don't Reject `
    }).then(result => {
      if (result && result.isConfirmed) {
        this.timeLineItem.ownerId = this.requisition.id;
        this.timeLineItem.type = TimeLineType.Note;
        this.timeLineItem.ownerEntityType = OwnerEntityType.Requisition;
        this.myTimelineNoteModalService.openModal(this.timeLineItem, false, OwnerEntityType.Requisition);
        var sub: Subscription = this.myTimelineNoteModalService.modelChanged.subscribe((result: any) => {
          if (result) {
            this.timeLineItem = new TimelineModel;
            this.requisition.status = RequisitionStatus.Draft;
            this.myFileApiService.updateRequisitionStatus(this.requisition, (`Requisition Rejected by: ${this.userContext?.firstName} ${this.userContext?.lastName}`)).subscribe((response: any) => {
              if (response) {
                this.updateList(RequisitionListUpdateValues.Default);
                this.toasterNotificationService.showSuccess($localize`:@@:Requisition Rejected`, $localize`:@@Toast_Success_GeneralTitle:Success`);
                this.modalRef.close();
              }
              this.spinnerIsShown = false
            });
          }
          sub.unsubscribe();
        })
      }
    })


  }
  accept() {
    this.updateStatusOnList(RequisitionStatus.Processing, `Process`, true);
  }

  incomplete() {
    if (this.checkForUnprocessedInvoices()) {
      this.updateStatusOnList(RequisitionStatus.Incompleted, `Incomplete`);
    }
  }

  complete() {
    if (this.checkForUnprocessedInvoices()) {
      this.updateStatusOnList(RequisitionStatus.Completed, `Complete`);
    }
  }

  checkForUnprocessedInvoices(): boolean {
    var allInvoicesAreCharged: boolean = true;
    if (this.model.myfileList.items) {
      this.model.myfileList.items.forEach(myfile => {
        if (myfile.type == TemplateDocumentType.Invoice && myfile.status == DocumentStatus.New) {
          this.toasterNotificationService.showError(`${myfile.name} has not been processed yet. It must be processed or deleted in order to complete the requisition.`, 'Error');
          allInvoicesAreCharged = false;
        }
      })
    }
    return allInvoicesAreCharged;
  }

  invoice() {
    this.spinnerIsShown = true;
    if (this.requisition.id) {
      Swal.fire({
        title: $localize`:@@:Select Tax`,
        icon: 'question',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        showDenyButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        denyButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@: Include Tax`,
        denyButtonText: $localize`:@@:No Tax`
      }).then(result => {
        var includeTax: boolean = false;
        if (result && result.isDismissed == false) {
          if (result.isConfirmed) {
            includeTax = true;
          }
          this.myFileApiService.createRequisitionInvoiceMyfile(this.requisition.id!, includeTax).subscribe((result) => {
            if (result) {
              this.myFileListService.startIndex = this.myFileListService.startIndex;
              this.myFileApiService.getMyFile(result.Id).subscribe((myfileInvoice: MyfileModel | undefined) => {
                if (myfileInvoice) {
                  myfileInvoice.customFields?.forEach((currentValue, index) => {
                    if (
                      currentValue.value == null
                      || currentValue.value == ''
                    ) {
                      switch (index) {
                        case 0:
                          currentValue.value = `${this.requisition.price || ''}`;
                          break;
                        case 1:
                          currentValue.value = `${this.requisition.processingFee || ''}`;
                          break;
                        case 2:
                          currentValue.value = ``;
                          break;
                        case 3:
                          currentValue.value = ``;
                          break;
                        case 4:
                          currentValue.value = ``;
                          break;
                      }
                    }
                  });
                  this.myFileModalService.openModal(myfileInvoice, this.requisition);
                  var sub: Subscription = this.myFileModalService.modelChanged.subscribe((result: any) => {
                    this.myfileCustomFieldsGroups = [];
                    this.myFileListService.startIndex = this.myFileListService.startIndex;
                    sub.unsubscribe();
                  })
                }
                this.spinnerIsShown = false;
              });
            } else {
              this.spinnerIsShown = false;
            }
          });
        } else {
          this.spinnerIsShown = false;
        }
      });
    } else {
      this.spinnerIsShown = false;
    }
  }

  chargeInvoice(myfile: MyfileModel) {
    this.spinnerIsShown = true;
    this.myFileApiService.getInvoice(myfile.id!).subscribe(invoice => {
      if (invoice) {
        Swal.fire({
          title: $localize`:@@:Charge ${myfile.name} for ${invoice.total} `,
          icon: 'question',
          color: 'var(--vz-body-color)',
          background: 'var(--vz-body-bg)',
          showDenyButton: true,
          confirmButtonColor: 'rgb(3, 142, 220)',
          denyButtonColor: 'rgb(243, 78, 78)',
          confirmButtonText: $localize`:@@:Charge`,
          denyButtonText: $localize`:@@:Cancel`
        }).then(result => {
          if (result.isConfirmed) {
            var payment: PaymentModel = new PaymentModel();
            payment.amount = invoice.total;
            payment.invoiceId = invoice.id;
            payment.sourceId = this.requisition!.id;
            payment.sourceNumber = this.requisition!.number;
            if (this.billableUser && this.billableUser.id) {
              payment.userId = this.billableUser.id;
            } else {
              payment.userId = this.requisition!.createdById; //defaults to createdBy
            }
            payment.description = myfile.name;
            if (this.authMyFileService.currentUserContextValue && this.authMyFileService.currentUserContextValue?.businessUnitId) {
              this.aiApiService.createPayment(payment).subscribe(result => {
                this.spinnerIsShown = false;
                if (result) {
                  this.toasterNotificationService.showSuccess(`${payment.description}.`, "Invoice Charged Successfuly")
                  this.myFileListService.startIndex = 1;
                }
              })
            } else {
              if (this.billableUser && this.billableUser.id) {
                this.aiApiService.getPaymentToken(this.billableUser.id).subscribe(paymentToken => {
                  if (paymentToken) {
                    payment.token = paymentToken.token;
                    this.spinnerIsShown = true;
                    this.aiApiService.createPayment(payment).subscribe(result => {
                      this.spinnerIsShown = false;
                      if (result) {
                        this.toasterNotificationService.showSuccess(`${payment.description}.`, "Invoice Charged Successfuly")
                        this.myFileListService.startIndex = 1;
                      }
                    })
                  } else {
                    this.spinnerIsShown = false;
                  }
                })
              } else {
                this.processPaymentToken(this.requisition!.createdBy!.paymentInfo, payment);
              }
            }
          } else {
            this.spinnerIsShown = false;
          }
        });
      }
    })
  }

  processPaymentToken(paymentInfo: CreditCardPaymentInfoModel, payment: PaymentModel) {
    this.aiApiService.createStripeToken(paymentInfo).subscribe(token => {
      this.spinnerIsShown = false;
      if (token) {
        payment.token = token.token;
        this.spinnerIsShown = true;
        this.aiApiService.createPayment(payment).subscribe(result => {
          this.spinnerIsShown = false;
          if (result) {
            this.toasterNotificationService.showSuccess(`${payment.description}.`, "Invoice Charged Successfuly")
            this.myFileListService.startIndex = 1;
          }
        })
      }
    })
  }

  refundInvoice(myfile: MyfileModel) {
    this.myFileApiService.getInvoice(myfile.id!).subscribe(invoice => {
      if (invoice) {
        var paymentsSearch: PaymentSearchModel = new PaymentSearchModel;
        paymentsSearch.invoiceId = invoice.id;
        this.aiApiService.getPaymentList(paymentsSearch).subscribe(result => {
          if (result) {
            var payment: PaymentModel = new PaymentModel();
            payment = result.items[0];

            Swal.fire({
              title: $localize`:@@:Select Refund Type`,
              icon: 'question',
              color: 'var(--vz-body-color)',
              background: 'var(--vz-body-bg)',
              showDenyButton: true,
              confirmButtonColor: 'rgb(3, 142, 220)',
              denyButtonColor: 'rgb(243, 78, 78)',
              confirmButtonText: $localize`:@@: Full Refund`,
              denyButtonText: $localize`:@@:Partial Refund`
            }).then(result => {
              if (result && result.isDismissed == false) {
                if (result.isConfirmed) {
                  this.aiApiService.refundPayment(payment.id!, payment.amount!.toString()).subscribe(result => {
                    if (result) {
                      this.toasterNotificationService.showSuccess($localize`:@@:Refunded: ` + payment.description + ` for ` + payment.amount, $localize`:@@Toast_Success_GeneralTitle:Success`);
                    }
                  })
                } else {
                  Swal.fire({
                    title: $localize`:@@:Refund Amount`,
                    input: "text",
                    inputPlaceholder: `Enter amount to refund up to: ${payment.amount}`,
                    color: 'var(--vz-body-color)',
                    background: 'var(--vz-body-bg)',
                    showDenyButton: true,
                    confirmButtonColor: 'rgb(3, 142, 220)',
                    denyButtonColor: 'rgb(243, 78, 78)',
                    confirmButtonText: $localize`:@@: Refund`,
                    denyButtonText: $localize`:@@:Cancel`
                  }).then(swalResult => {
                    if (swalResult.isConfirmed) {
                      if (swalResult.value > payment.amount!) {
                        this.toasterNotificationService.showError($localize`:@@: Refund amount to high.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
                      } else {
                        this.aiApiService.refundPayment(payment.id!, swalResult.value.toString()).subscribe(result => {
                          if (result) {
                            this.toasterNotificationService.showSuccess($localize`:@@:Refunded: ` + payment.description + ` for ` + swalResult.value, $localize`:@@Toast_Success_GeneralTitle:Success`);
                          }
                        })
                      }
                    }
                  })

                }
              }
            });
          }
        });
      }
    })
  }



  cheque(invoiceID?: string, invoice?: InvoiceModel) {
    this.spinnerIsShown = true;

    if (invoiceID != undefined && invoice == undefined) {
      if (invoiceID && this.requisition.id) {
        this.myFileApiService.getInvoice(invoiceID).subscribe(invoiceModel => {
          this.cheque(undefined, invoiceModel)
        });
      }
    } else {
      if (this.requisition.id) {
        this.myFileApiService.createRequisitionChequeMyfile(this.requisition.id).subscribe((result) => {
          if (result) {
            this.myFileListService.startIndex = this.myFileListService.startIndex;
            this.myFileApiService.getMyFile(result.Id).subscribe(((cheque: MyfileModel | undefined) => {
              if (cheque) {
                cheque.customFields?.forEach((currentValue, index) => {
                  switch (index) {
                    case 0:
                      if (invoice) {
                        currentValue.value = `${invoice.lineItems[0].amount || ''}`;
                      } else {
                        currentValue.value = `${this.requisition.price || ''}`;
                      }
                      break;
                    case 1:
                      currentValue.value = ``;
                      break;
                    case 2:
                      if (invoice) {
                        currentValue.value = `${invoice.lineItems[0].description || ''}`;
                      } else {
                        currentValue.value = `${this.requisition.account.companyName || this.requisition.account.fullName || ''}`;
                      }
                      break;
                    case 3:
                      currentValue.value = `${this.requisition.account.address.unit || ''}, ${this.requisition.account.address.streetNumber || ''} ${this.requisition.account.address.address1 || ''}`;
                      break;
                    case 4:
                      currentValue.value = `${this.requisition.account.address.city || ''}, ${this.requisition.account.address.province || ''} ${this.requisition.account.address.postalCode || ''}`;
                      break;
                    case 5:
                      var lastNameCaps = ""
                      if (this.requisition.client.lastName) {
                        lastNameCaps = this.requisition.client.lastName.toUpperCase();
                      }
                      currentValue.value = `${lastNameCaps || ''}, ${this.requisition.client.name || ''} - ${this.requisition.type || ''}`;
                      break;
                    case 7:

                      if (invoice && invoice.calculateTax) {
                        currentValue.value = `${invoice.calculateTax}`;
                      } else {
                        currentValue.value = `false`;
                      }

                      break;
                  }
                });
                this.myFileModalService.openModal(cheque, this.requisition);
                var sub: Subscription = this.myFileModalService.modelChanged.subscribe((result: any) => {
                  this.myfileCustomFieldsGroups = [];
                  this.myFileListService.startIndex = 1;
                  sub.unsubscribe();
                })
              }
              this.spinnerIsShown = false;
            }))
          } else {
            this.spinnerIsShown = false;
          }
        })
      } else {
        this.spinnerIsShown = false;
      }
    }
    this.spinnerIsShown = false;
  }

  delete() {
    if (this.requisition.id) {
      this.myFileApiService.deleteRequisition(this.requisition.id).subscribe((response: any) => {
        if (response) {
          this.updateList(RequisitionListUpdateValues.Delete);
          this.toasterNotificationService.showSuccess($localize`:@@:Requisition removed: ` + this.requisition.number, $localize`:@@Toast_Success_GeneralTitle:Success`);
          this.modalRef.close();
        }
      });
    }
  }

  onUpdate() {
    if (this.validate()) {
      if (this.requisition.client.id && this.requisition.account.id) {
        this.requisition.clientId = this.requisition.client.id;
        this.requisition.accountId = this.requisition.account.id;
        this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, true);
        this.spinnerIsShown = true;
        if (this.myfile.customFields) {
          this.myfile.customFields.forEach(element => {
            if (element.dataType == 2) {
              if (element.value) {
                element.value = this.swapFormat(element.value);
              }
            }
          });
        }
        this.updateMyfileList();
        this.myFileApiService.updateMyFile(this.myfile).subscribe((response: any) => {
          if (response) {
            this.myFileApiService.updateRequisition(this.requisition).subscribe((response: any) => {
              if (response) {
                this.updateList(RequisitionListUpdateValues.Default);
                this.toasterNotificationService.showSuccess($localize`:@@:Requisition: ` + this.requisition.number + ` updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
                this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, false);
                if (this.myfile.customFields) {
                  this.myfile.customFields.forEach(element => {
                    if (element.dataType == 2) {
                      if (element.value) {
                        element.value = this.swapFormat(element.value);
                      }
                    }
                  });
                }
                this.contactEdited = false;
              }
              this.spinnerIsShown = false;
            });
          } else {
            this.requisition.dateOfLoss = GlobalComponent.dateTransform(this.requisition.dateOfLoss, false);
            this.spinnerIsShown = false;
          }
        });

      }
    }
  }

  sendApprovalRequest(invoice: MyfileModel) {
    Swal.fire({
      title: $localize`:@@:Invoice Approval Request`,
      text: $localize`:@@:Are you sure you want to send Invoice ${invoice.name} for approval to ${this.model.requisition?.createdBy?.email}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Send`,
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result.isConfirmed) {
        var approvalModel: InvoiceApprovalRequestModel = new InvoiceApprovalRequestModel();
        approvalModel.approvalUserId = this.model.requisition!.createdById;
        approvalModel.requisitionId = this.model.requisition!.id;
        approvalModel.myfileId = invoice.id;
        approvalModel.approvalUrl = window.location.protocol + "//" + window.location.host + '/auth/invoice-approval'

        this.myFileApiService.sendEmailInvoiceApprovalRequest(approvalModel).subscribe(result => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@:Signature request sent successfully`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
        })

      }
    });
  }

  updateStatusOnList(requisitionStatus: RequisitionStatus, textToStatusChange: string, keepOpenAfterUpdate?: boolean) {
    Swal.fire({
      title: $localize`:@@:${textToStatusChange} Requisition`,
      text: $localize`:@@SWAL_AreYouSureLeave:Are you sure you want to ${textToStatusChange} this requisition?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Yes, ${textToStatusChange} `,
      cancelButtonText: $localize`:@@:No, don't ${textToStatusChange} `
    }).then(result => {
      if (result && result.isConfirmed) {
        this.spinnerIsShown = true
        this.requisition.status = requisitionStatus;
        if (textToStatusChange.endsWith('t')) {
          textToStatusChange = `${textToStatusChange}ted`
        } else if (textToStatusChange.endsWith('e')) {
          textToStatusChange = `${textToStatusChange}d`
        } else {
          textToStatusChange = `${textToStatusChange}ed`
        }
        this.myFileApiService.updateRequisitionStatus(this.requisition, (`Requisition ` + textToStatusChange + ` by: ${this.userContext?.firstName} ${this.userContext?.lastName}`)).subscribe((response: any) => {
          if (response) {
            this.updateList(RequisitionListUpdateValues.Default);
            this.toasterNotificationService.showSuccess($localize`:@@:Requisition ${textToStatusChange}`, $localize`:@@Toast_Success_GeneralTitle:Success`);
            if (keepOpenAfterUpdate) {
              this.requisitionStatus = this.requisition.status
            } else {
              this.modalRef.close();
            }
          }
          this.spinnerIsShown = false
        });
      }
    });
  }

  openModal(modal: ModalType, model: any) {
    if (modal == ModalType.ClientModalPickList) {
      this.myClientViewService.openModal(model);
      var sub: Subscription = this.myClientViewService.modelChanged.subscribe((result: any) => {
        this.requisition.client = result;
        this.requisition.matterNumber = result.matterNumber;

        if (result.dateOfLoss) {
          this.requisition.dateOfLoss = result.dateOfLoss.substring(8, 10) + result.dateOfLoss.substring(5, 7) + result.dateOfLoss.substring(0, 4);
        } else {
          this.requisition.dateOfLoss = GlobalComponent.defaultDate;
        }
        sub.unsubscribe();

      })
    } else if (modal == ModalType.ContactModalPickList) {
      this.myContactViewService.openModal(model);
      var sub: Subscription = this.myContactViewService.modelChanged.subscribe((result: any) => {
        this.requisition.account = result;
        sub.unsubscribe();
      })
    }
  }

  clientChosen(event: any, result: ClientModel) {

    this.requisition.matterNumber = result.matterNumber;
    if (result.dateOfLoss) {
      this.requisition.dateOfLoss = result.dateOfLoss.substring(8, 10) + result.dateOfLoss.substring(5, 7) + result.dateOfLoss.substring(0, 4);
    } else {
      this.requisition.dateOfLoss = GlobalComponent.defaultDate;
    }
    this.changeDetector.detectChanges();
  }

  contactChosen(event: any, result: ContactModel) {
    this.changeDetector.detectChanges();
  }

  myfileRename(name: string | undefined) {
    if (name) {
      name = name.split('#')[0]
    }
    return name;
  }

  dateRename(date: Date | undefined) {
    if (date) {
      return GlobalComponent.dateTransform(date.toString(), false)
    } else {
      return '';
    }
  }

  viewMyfile(myfileModel: MyfileModel) {
    this.spinnerIsShown = true;
    if (this.model.requisition && this.model.requisition.id && myfileModel.id) {
      this.myFileApiService.viewMyFile(this.model.requisition.id, myfileModel.id).subscribe((result: any) => {
        this.pdfModalService.openModal(result, myfileModel.name);
        this.aIChatModalService.setOpenModalId(this.model.requisition!.id, myfileModel.id, EntityTypeEnum.Requisition, myfileModel.name);
        var sub: Subscription = this.pdfModalService.modelChanged.subscribe(() => {
          this.spinnerIsShown = false;
          sub.unsubscribe();
        })
      });
    }
  }

  myfileRequestSignature(myfileModelId: string | undefined) {
    if (this.model.requisition && this.model.requisition.clientId && this.model.requisition.client.email) {
      var clientSigRequest: ClientSignatureRequestModel = new ClientSignatureRequestModel;

      clientSigRequest.clientId = this.model.requisition.clientId;
      clientSigRequest.email = this.model.requisition.client.email;
      clientSigRequest.requisitionId = this.model.requisition.id
      clientSigRequest.myFileId = myfileModelId;
      clientSigRequest.showPdfPreview = true;
      this.clientSignatureModalService.openModal(clientSigRequest, this.model.requisition.client.fullName);
      var sub: Subscription = this.clientSignatureModalService.modelChanged.subscribe((result: any) => {
        if (result) {
          this.updateTimeLineForSignatureSubmission(result.email, false, false);
        }
        sub.unsubscribe();
      })
    }
  }

  editMyfile(myfileModel: MyfileModel | undefined) {
    this.spinnerIsShown = true;
    if (myfileModel && myfileModel.id && this.requisition.id) {
      this.myFileApiService.getMyFile(myfileModel.id).subscribe((myfileModel: MyfileModel | undefined) => {
        if (myfileModel) {
          this.myFileModalService.openModal(myfileModel, this.requisition);
          var sub: Subscription = this.myFileModalService.modelChanged.subscribe((result: any) => {
            this.myFileListService.startIndex = this.myFileListService.startIndex;
            sub.unsubscribe();
          })
        }
        this.spinnerIsShown = false;
      });
    } else {
      this.spinnerIsShown = false;
    }
  }

  downloadMyfile(myfileModelId: string | undefined) {
    this.spinnerIsShown = true;
    if (this.model.requisition && this.model.requisition.id && myfileModelId) {
      this.myFileApiService.downloadMyFile(this.model.requisition.id, myfileModelId).subscribe((result: any) => {
        this.spinnerIsShown = false
      });
    }
  }

  deleteMyfile(myfileModelId: string | undefined, index: number) {
    if (myfileModelId) {
      this.submitted = true;
      Swal.fire({
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        title: $localize`:@@:Delete Document`,
        text: $localize`:@@:Are you sure you want to delete this document?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result && result.isConfirmed) {
          this.myFileApiService.deleteMyFile(myfileModelId).subscribe((result: ErrorModel | boolean | undefined) => {
            if (result) {
              this.myFileListService.startIndex = 1;
              this.toasterNotificationService.showSuccess($localize`:@@: Myfile has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
            }
            this.submitted = false;
          });
        } else {
          this.submitted = false;
        }
      });

    }
  }

  statusTextClass(status: DocumentStatus | undefined) {
    switch (status as DocumentStatus) {
      case DocumentStatus.Completed:
        return 'coloredTextArea green';
      case DocumentStatus.Approved:
        return 'coloredTextArea orange';
      case DocumentStatus.New:
        return 'coloredTextArea purple';
      case DocumentStatus.Rejected:
        return 'coloredTextArea red';
      case DocumentStatus.Signed:
        return 'coloredTextArea blue';
      case DocumentStatus.PendingApproval:
        return 'coloredTextArea blue';
      case DocumentStatus.Processed:
        return 'coloredTextArea yellow';
      default:
        return 'coloredTextArea red';
    }
  }

  statusTextMyfile(status: DocumentStatus | undefined) {
    switch (status) {
      case DocumentStatus.New:
        return $localize`:@@Status_Document_TextNew:New`;
      case DocumentStatus.Signed:
        return $localize`:@@Status_Document_TextSigned:Signed`;
      case DocumentStatus.Approved:
        return $localize`:@@Status_Document_TextApproved:Approved`;
      case DocumentStatus.Rejected:
        return $localize`:@@Status_Document_TextRejected:Rejected`;
      case DocumentStatus.PendingApproval:
        return $localize`:@@:Pending Approval`;
      case DocumentStatus.Processed:
        return $localize`:@@:Processed`;
      case DocumentStatus.Completed:
        return $localize`:@@Status_Document_TextCompleted:Completed`;
      default:
        return $localize`:@@Status_Document_TextOther:Other`;
    }
  }

  getMyfileBoolValue(value: string | undefined): boolean {
    if (value) {
      if (value == "☑") {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  setMyfileBoolValue(value: string | undefined, groupIndex: number, subGroupIndex: number, myfileIndex: number) {
    if (this.myfileCustomFieldsGroups[groupIndex] && this.myfileCustomFieldsGroups[groupIndex].subgroups[subGroupIndex] && this.myfileCustomFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex]) {
      if (value) {
        if (value == `☐`) {
          this.myfileCustomFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☑`

        } else {
          this.myfileCustomFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☐`
        }
      } else {
        this.myfileCustomFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☐`
      }
    }
  }

  updateMyfileList() {
    this.myfile.customFields = [];
    this.myfileCustomFieldsGroups.forEach(group => {
      group.subgroups.forEach(subgroup => {
        subgroup.group.forEach(myfile => {
          this.myfile.customFields?.push(myfile);
        });
      });
    })
    this.myfile.customFields = this.updateMyfileDropdownValues(this.myfile.customFields);
  }

  updateMyfileDropdownValues(customFields: any[]): any[] {
    customFields.forEach((customField: any) => {
      if (customField.dataType === DataType.DropDown) {
        customField.keyValues.forEach((element: { isSelected: boolean; }) => {
          element.isSelected = false;
        });
        if (customField.keyValues![customField.keyValues!.findIndex((element: { value: any; }) => element.value == customField.value)] !== undefined && customField.keyValues![customField.keyValues!.findIndex((element: { value: any; }) => element.value == customField.value)] !== null) {
          customField.keyValues![customField.keyValues!.findIndex((element: { value: any; }) => element.value == customField.value)].isSelected = true;
        }
      }
    })
    return customFields;
  }

  accordionCloseAll() {
    this.pageAccordions.forEach(acc => {
      acc.collapseAll()
    })
    this.accordionIsCollapsed = true;
  }

  accordionOpenAll() {
    this.pageAccordions.forEach(acc => {
      acc.expandAll()
    })
    this.accordionIsCollapsed = false;
  }

  objectsEqual = (o1: any, o2: any) =>
    Object.keys(o1).length === Object.keys(o2).length
    && Object.keys(o1).every(p => o1[p] === o2[p]);

  editAssignees() {
    this.spinnerIsShown = true;
    this.assigneesModalService.openModal(this.requisition.assignees, this.requisition.assigneeIds);
    var sub: Subscription = this.assigneesModalService.modelChanged.subscribe((result: { userList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, changed: boolean }) => {

      if (result.changed) {
        this.requisition.assignees = result.userList;
        this.requisition.assigneeIds = result.assigneeIds;
        this.onUpdate();
      } else {
        this.spinnerIsShown = false;
      }
      sub.unsubscribe();
    })

  }

}